import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { ModelTagResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  children: (response: ModelTagResponse[]) => ReactElement
}

const GetAiModelTagsRequest = ({
  id,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/models/${id}/tags`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      url={url}
    />
  )
}

export default GetAiModelTagsRequest
